const data = [
	{
		title : "HTML",
		imgLink : "https://ik.imagekit.io/hbj42mvqwv/html_8HFcUIhFv0.png",
		meter : "80%",
		animation: "meterFill80 2s"
	},
	{
		title : "CSS",
		imgLink : "https://ik.imagekit.io/hbj42mvqwv/css_f4xU-WMm7b.png",
		meter : "80%",
		animation: "meterFill80 2s"
	},
	{
		title : "JAVASCRIPT",
		imgLink : "https://ik.imagekit.io/hbj42mvqwv/js_i4EEhZT2cA.png",
		meter : "60%",
		animation: "meterFill60 2s"
	},
	{
		title : "JEKYLL",
		imgLink : "https://ik.imagekit.io/hbj42mvqwv/jekyll_nVmoyGyOqJ.png",
		meter : "70%",
		animation: "meterFill70 2s"
	},
	{
		title : "REACT.JS",
		imgLink : "https://ik.imagekit.io/hbj42mvqwv/react_TERYb5yTI.png",
		meter : "80%",
		animation: "meterFill80 2s"
	},
	{
		title : "Express.JS",
		imgLink : "https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png",
		meter : "60%",
		animation: "meterFill60 2s"
	},
	{
		title : "WEB SCRAPING",
		imgLink : "https://ik.imagekit.io/hbj42mvqwv/scraping_U8dgpZ7R1e.png",
		meter : "60%",
		animation: "meterFill60 2s"
	},
	{
		title : "PHOTOSHOP",
		imgLink : "https://ik.imagekit.io/hbj42mvqwv/ps_n6DnzE8bpx.png",
		meter : "50%",
		animation: "meterFill50 2s"
	},
	{
		title : "Illustrator",
		imgLink : "https://img.pngio.com/buy-adobe-education-contact-multiblue-a-356422-png-images-pngio-illustrator-png-600_600.png",
		meter : "50%",
		animation: "meterFill50 2s"
	}
]
export default data